import React from 'react';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Navbar from './components/Organisms/Navbar';
import Main from './components/SuperOrganisms/Main';
import Insp from './components/SuperOrganisms/insp';
import Des from './components/SuperOrganisms/des';
import Code from './components/SuperOrganisms/code';
import ArticlePage from './components/SuperOrganisms/Article';
import Footer from './components/Organisms/Footer';
import NotFound from './components/SuperOrganisms/404';

const App = () => {
  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
            <Route index path='/justy/' element={<Main />} />
            <Route index path='/justy/insp' element={<Insp />} />
            <Route index path='/justy/des' element={<Des />} />
            <Route index path='/justy/code' element={<Code />} />
            <Route index path='/justy/:id' element={<ArticlePage />} />
            <Route index path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
};


export default App;
